import $http from "../../axios";
import * as mutations from './mutations'
import {Notification, MessageBox} from "element-ui";

export async function searchDocuments({ commit, state,dispatch }) {

    var params = {
        params: state.tableDocuments.params
    };
    commit('setDefautlState')
    await $http
        .get("/api/documento/buscar/", params)
        .then(response => {
            if (response.data.length){
                dispatch("getDocumentById", response.data[0].id);
            }else {
                Notification.error({
                title: "Error!",
                message: "No se han Encotrado Documentos",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            }

        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al buscar el documento",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });

    state.tableDocuments.loading = false;
}
export async function searchDocumentById({ commit, state },id) {


    await $http
        .get("/api/buscar-documento/"+id)
        .then(response => {
            commit("setSearchDocuments", [response.data.data]);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al buscar el documento",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });

    state.tableDocuments.loading = false;
}
export async function fetchModelsLite({ commit, state }) {
    await $http
        .get("/api/modelos-lite")
        .then(response => {
            commit("fetchModelsLite", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al obtener los documentos",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchWarehousesContact({commit,state}, requestParameters = {params: state.paramsquery}) {
    await $http.get('/api/warehouses-contact', requestParameters)
        .then((response) => {
            commit('setWarehousesContact', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
export async function fetchSellers({commit,state}, filter) {
    let params = { filter:filter }
    await $http.get('/api/lista-vendedores', {params})
        .then((response) => {
            commit('setSellers', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
export async function fetchAccountsDoc({commit, state}){
    let params = {
        params: {}
    };

    await $http
        .get("/api/cuentas-lite", params)
        .then(response => {
            commit("setAccountsDoc", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchDeleteProduct({commit, state},document_product_id){
    await $http
        .delete(`/api/documento/eliminar-item-inventario/${document_product_id}`)
        .then(response => {
            Notification.success({
                title: "Success!",
                message: "Producto Eliminado correctamente Correctamente",
                type: "success",
                duration: 3000,
                customClass: "notification-box"
            });
            commit("setDocumentProductDeleted", true);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
}
export async function fetchTypesOperation({commit, state}) {
    let params = {
        params: {
            paginate: false
        }
    };

    await $http.get("/api/types_operations", params).then(res => {
        commit("setTypesOperationDocsPro", res.data.data);
    }).catch(error => {
        Notification.error({
            title: "¡Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
}
export async function searchProductsDocs({state,commit}, filter) {
    let params ={
        filter : filter,
        paginate : false,
        branchoffice_id: localStorage.selected_branchoffice,
        branchoffice_warehouse_id: localStorage.selected_branchoffice_warehouse
    }
    await $http.get('/api/lista-productos', {params}).then((response) => {
        commit('setProductsDocsPro', response.data.data.data)
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: "Error al buscar el producto",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
}

export async function validateRounding({state,commit}, data) {
    let params = data
    let response  = false 
    await $http.get('/api/validar-redondeo', {params}).then((api_response) => {
        response = api_response.data.data
    }).catch(error => {
        log.error('error al validar redondeo')
        Notification.error({
            title: "Error!",
            message: "Error",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
    return response
}
export async function cancelDocumentDocs({state,commit},document_id, observation) {
    let params ={
        observation
    }

    await $http.post(`/api/anular-documento/${document_id}`, {params}).then((response) => {
        Notification.success({
            title: "Success!",
            message: "Documento Anulado Correctamente",
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });
        state.loading.module = false
        commit('setDefautlState', response.data)
    }).catch(error => {
        state.loading.module = false
        Notification.error({
            title: "Error!",
            message: "Error Al Anular El Documento",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
}
export async function updateDocumentDocs({state,commit, dispatch}) {

    state.message = 'Actualizando'
    state.loading.module = true
    await $http.post(`/api/documento/actualizar-documento-inventario/${state.update_document.id}`, state.update_document).then((response) => {
        state.message = 'Cargando ...'
        state.loading.module = false
        dispatch('updateDocumentFilesDocs', state.update_document.id)
    }).catch(error => {
        let message = ''
        if (error.response && error.response.data && error.response.data.message){
             message = error.response.data.message
        }

        state.message = 'Cargando ...'
        state.loading.module = false
        Notification.error({
            title: "Error!",
            message: message? message : "Error Al Actualizar El Documento",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
}
export async function fetchStatesBackOrder({commit, state}, ) {
    await $http
        .get("/api/parametros-por-codigo/050")
        .then(response => {
            commit("setStatesBackOrder", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
            commit("modelError", error.message);
        });
}
export async function fetchBranchOfficeWarehousesDocs({dispatch, state, rootState, commit},branchoffice_id) {
    let params = {
        params: {
            branchoffice_id: branchoffice_id,
            paginate: false
        }
    };
    await $http.get("/api/bodegas-sedes",params).then(res => {
        commit("setBranchofficeWarehousesDocs", res.data.data);
    }).catch(error => {
        Notification.error({
            title: "¡Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
}
export async function calculateRetentions({ commit, state },id) {

    state.tableDocuments.loading = true;
    await $http
        .get("/api/retenciones/"+id)
        .then(response => {
            Notification.success({
                title: "Success!",
                message: "Retenciones Calculadas",
                type: "success",
                duration: 3000,
                customClass: "notification-box"
            });
            commit("setRetentionsDocument", [response.data.data]);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: "Error al Calcular las retenciones",
                type: "error",
                duration: 1500,
                customClass: "notification-box"
            });
        });
    state.tableDocuments.loading = false;
}
export async function fetchProjectsActive({commit, state}, text) {
    let params = { filter:text, status:1, paginate: false,}
    await $http.get('/api/proyectos-activos', {params} )
        .then((response) => {
            commit('setProjectsDocs', response.data.data)

        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box',
            });
        })
}
export async function updateDocumentFilesDocs({state,commit},document_id) {

    let formData = new FormData();

    state.document_files_new.map(fn => {
        formData.append("filesUpload[]", fn);
    });
    state.document_files_delete.map(fn => {
        formData.append("filesDelete[]", JSON.stringify(fn));
    });

    state.message = 'Actualizando'
    state.loading.module = true
    await $http.post(`/api/documento/files/${document_id}`, formData).then((response) => {
        state.message = 'Cargando ...'
        state.loading.module = false
        Notification.success({
            title: "Success!",
            message: "Documento Actualizado Correctamente los saldos se actualizaran en breve",
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });

        MessageBox.confirm('Documento Actualizado Correctamente. Los Saldos Se Actualizarán En Breve', 'Actualización de Documento', {
                confirmButtonText: 'Aceptar',
                cancelButtonText: 'Cancelar',
                type: 'warning',
                customClass: 'notification-warning'
            })
            .then((result) => {})
            .catch((error) => {})

        commit('setDefautlState', response.data)
    }).catch(error => {
        let message = ''
        if (error.response && error.response.data && error.response.data.message){
            message = error.response.data.message
        }

        state.message = 'Cargando ...'
        state.loading.module = false
        Notification.error({
            title: "Error!",
            message: message? message : "Error Al Actualizar El Documento",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });
}
export async function downloadFile({commit, state}, file){
    await $http({
        url: `/api/descargar-archivo`,
        params : file,
        method: 'GET',
        responseType: 'blob',
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', file.name);
        document.body.appendChild(link);
        link.click();
    }).catch((error) => {
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });

    })
    // await $http
    // .get()
    // .then(response => {
    //   // commit("setaccountselect", response.data.data);
    // })
    // .catch(error => {
    //   let data = error.response.data
    //   Notification.error({
    //     title: "Error!",
    //     message: data.message,
    //     type: "error",
    //     duration: 1500,
    //     customClass: "notification-box"
    //   });
    // });
}

export async function getDocumentById({commit, state}, id){
    await $http.get(`/api/buscar-documento/${id}`).then(response => {
        let doc = response.data.data
        if (doc){
            if (doc.vouchertype && doc.vouchertype.code_voucher_type === '100'){
                Notification.error({
                    title: 'Error!',
                    message: 'No es posible modificar traslados: Deber devolver los productos o realizar el ajuste de inventario respectivo',
                    type: 'error',
                    duration: 3000,
                    customClass: 'notification-box',
                });

            }else{
                commit("setSearchDocuments", [doc]);
            }
        }

    }).catch(error => {
        Notification.error({
            title: "¡Error!",
            message: error.message,
            type: "error",
            duration: 1500,
            customClass: "notification-box"
        });
    });

}



// WEBPACK FOOTER //
// ./src/modules/manage-inventory-documents/actions.js